module.exports = __webpack_public_path__ + "img/search-course-empty-img.36c2d219.png";